function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.7419 5.96777H2.25809C1.01291 5.96777 0 6.98062 0 8.2258V21.7742C0 23.019 1.01291 24.0323 2.25809 24.0323H27.742C28.9868 24.0323 30.0001 23.0191 30.0001 21.7742V8.2258C30 6.98062 28.9868 5.96777 27.7419 5.96777ZM28.0645 21.7742C28.0645 21.949 27.9168 22.0968 27.742 22.0968H2.25809C2.08324 22.0968 1.93553 21.949 1.93553 21.7742V8.2258C1.93553 8.05096 2.08324 7.90324 2.25809 7.90324H27.742C27.9168 7.90324 28.0645 8.05096 28.0645 8.2258V21.7742Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.41938 6.61292V8.06452C3.41938 8.78809 2.85261 9.35481 2.12909 9.35481H0.709717V11.2903H2.12909C3.90782 11.2903 5.35491 9.84319 5.35491 8.06446V6.61292H3.41938Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.9033 9.35487C27.1797 9.35487 26.613 8.78809 26.613 8.06458V6.61292H24.6775V8.06452C24.6775 9.84325 26.1246 11.2903 27.9033 11.2903H29.3549V9.35487H27.9033Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.16132 18.7097H0.709717V20.6452H2.16132C2.88489 20.6452 3.45161 21.212 3.45161 21.9355V23.3871H5.38714V21.9355C5.38714 20.1568 3.94005 18.7097 2.16132 18.7097Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.9031 18.7097C26.1243 18.7097 24.6772 20.1568 24.6772 21.9355V23.3871H26.6127V21.9355C26.6127 21.212 27.1795 20.6452 27.903 20.6452H29.3546V18.7097H27.9031Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0066 11.1543C17.9814 10.1288 16.616 9.56433 15.1611 9.56433C13.7066 9.56433 12.3408 10.1288 11.3156 11.1543C10.2901 12.1795 9.72559 13.5453 9.72559 14.9998C9.72559 16.4547 10.2901 17.8201 11.3156 18.8453C12.3407 19.8708 13.7066 20.4357 15.1611 20.4357C16.6159 20.4357 17.9814 19.8708 19.0066 18.8453C20.0321 17.8202 20.597 16.4547 20.597 14.9998C20.597 13.5453 20.0321 12.1795 19.0066 11.1543ZM17.6383 17.4769C16.9786 18.1366 16.0989 18.5002 15.1612 18.5002C14.2234 18.5002 13.3438 18.1366 12.684 17.4769C12.0243 16.8173 11.6611 15.9376 11.6611 14.9998C11.6611 14.0621 12.0247 13.1824 12.6843 12.5227C13.344 11.863 14.2237 11.4998 15.1611 11.4998C16.0985 11.4998 16.9785 11.863 17.6382 12.523C18.2979 13.1827 18.6614 14.062 18.6614 14.9998C18.6615 15.9376 18.2979 16.8172 17.6383 17.4769Z",
  fill: "#343434"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white"
})));

function SvgCashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/CashIcon.51983444.svg";
export { ForwardRef as ReactComponent };